import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

/**
 * Flow A/B shared warning — the extracted (DOR-printed) business name doesn't closely
 * match the selected client's legal/DBA name. Fail-open: only rendered when the caller
 * has already determined `show` (backend `businessNameMatch === false`) and there's a
 * name to display. Reused by Task 8's Flow B wiring.
 */
export function NameMismatchWarning(props: {
  extractedName?: string | null;
  clientName: string;
  show: boolean;
}) {
  const { t } = useTranslation();
  if (!props.show || !props.extractedName) return null;
  return (
    <MessageBar intent="error">
      <MessageBarBody>
        {t('clientDetailPage.nameGuard.warning', {
          extracted: props.extractedName,
          client: props.clientName,
        })}
      </MessageBarBody>
    </MessageBar>
  );
}
